var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{staticClass:"uno",attrs:{"cols":"7"}},[_c('h3',{staticClass:"text textOne"},[_vm._v("Usuarios")])]),_c('b-col',{staticClass:"two",attrs:{"cols":"5"}},[_c('h3',{staticClass:"text"},[_vm._v("Gestionar Accesos")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }